import { useDispatch } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { StoreState } from 'store';

export const useAppDispatch: () => ThunkDispatch<StoreState, any, AnyAction> = useDispatch;
